export class FetchAttachmentsRequest {
    constructor(values?: Partial<FetchAttachmentsRequest>) {
        Object.assign(this, values);
    }

    orgId: string = "";
    ssoId: string = "";
    email: string = "";
    status: string[] = [];
    formType: string = "";
    caseSysId: string = "";
    attachSysId: string = "";

    public static parseValues(json: any) {
        if(!json) {
            return new FetchAttachmentsRequest();
        }

        const req = {
            orgId: json.orgId,
            ssoId: json.ssoId,
            email: json.email,
            status: json.status,
            formType: json.formType,
            caseSysId: json.caseSysId,
            attachSysId: json.attachSysId
        }

        return new FetchAttachmentsRequest(req);
    }
}
